export const BestsellersModuleName = 'Bestsellers';